import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { SimpleIconsApachekafkaComponent } from './simple-icons-apachekafka.component';
 @NgModule({
    imports:      [ BrowserModule ],
    providers:    [],
    declarations: [ SimpleIconsApachekafkaComponent ],
    exports:      [ SimpleIconsApachekafkaComponent ],
    bootstrap:    []
})
export class SimpleIconsApachekafkaModule {}
